function initMatching(){

    initMatchingButtons();
}

function initMatchingButtons(){

    //lots of other slidepanels are using this
    $('#saveMatchingAction').click(function(){

        var target = $(this).attr('data-targetform');
        var $target = $(target);
        //   console.log(target);
        $(window).trigger('beforeajaxsaving');
        var l = Ladda.create(this);
        l.start();

        $.post($target.attr('action'), $target.serialize())
            .done(function(data){
                if (data.status){
                 //   $('#filter').trigger('filter:refresh');
                    $('#filter').trigger('filter:refreshpage');
                    $('.slidePanel-close').trigger('click');
                }else{
                    window.errorsCheck(data);
                }

            })
            .always(function() { l.stop(); });

    });

}